export class CashDevicesState {
  isCashPayIn = false;
  isCashPayOut = false;

  static fromOther(other: CashDevicesState): CashDevicesState {
    return Object.assign(new CashDevicesState(), other);
  }
}
